"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRefundPayload = exports.createCancelPayload = exports.getSubscriptionEndDateForCancelPayload = exports.getRenewalSeasonValue = exports.membershipBodyToLegalEntity = exports.isFeeProduct = exports.isCertificateProduct = exports.isCenterMembership = exports.isSectionProduct = exports.isCredentialProduct = exports.isCenterMembershipProduct = exports.isMembershipProduct = exports.getProductMembershipApplicationTypes = exports.checkProductMembershipApplicationType = exports.isVariantWithValidDates = exports.isVariantWithValidPrice = exports.attributesToObject = exports.getProductPrice = exports.FETCH_PRODUCTS_EXPANSION_PART = exports.includesUnindexableProducts = exports.getUpcomingVariants = exports.transformCpeCredits = exports.variantsPriceInfoForUser = exports.userApplicableVariantsPricing = void 0;
// eslint-disable-next-line import/no-extraneous-dependencies
const moment_1 = __importDefault(require("moment"));
const mxp_schemas_1 = require("mxp-schemas");
const user_1 = require("../user");
const utils_1 = require("../utils");
const sortByPrice = (a, b) => {
    return (a ? a.price.amount : 0) - (b ? b.price.amount : 0);
};
const sortByName = (a, b) => {
    if ((a ? a.membershipName : '') < (b ? b.membershipName : ''))
        return -1;
    if ((a ? a.membershipName : '') > (b ? b.membershipName : ''))
        return 1;
    return 0;
};
const sortByDiscountName = (a, b) => {
    if (((a === null || a === void 0 ? void 0 : a.appliedDiscountName) || '') < ((b === null || b === void 0 ? void 0 : b.appliedDiscountName) || ''))
        return -1;
    if (((a === null || a === void 0 ? void 0 : a.appliedDiscountName) || '') > ((b === null || b === void 0 ? void 0 : b.appliedDiscountName) || ''))
        return 1;
    return 0;
};
/**
 *
 * @param variants array of variant (straight from a product object)
 * @param roles user roles configued in Okta
 * @returns Map<string, Product.Price[]> array of prices that are applicable to the user
 */
const userApplicableVariantsPricing = (variants, roles, isContribution, currencyPrice, tier, priceBookEntries) => {
    const priceBookMap = new Map();
    priceBookEntries === null || priceBookEntries === void 0 ? void 0 : priceBookEntries.forEach(priceBookEntry => {
        if (priceBookEntry.unitPrice > 0)
            priceBookMap.set(priceBookEntry.productSku, priceBookEntry);
    });
    const userRoles = roles || [];
    const productVariants = variants || [];
    const availabilityPriceInfoList = transformVariantPricesToAvailabilityInfo(productVariants, currencyPrice, tier, priceBookMap);
    // convert variants to hashmap of variant ids
    return productVariants.reduce((pricesMap, variant) => {
        const variantPrices = (0, utils_1.getUpdatedPrices)(variant.prices, currencyPrice, tier) || [];
        // filter the and convert variant prices
        const variantSKU = variant.sku;
        pricesMap[variantSKU] = variantPrices
            .map((price) => {
            var _a;
            const applicableUserRoles = price.channel.applicableUserRoles;
            if (price.channel && applicableUserRoles) {
                const membershipName = transformRoles(price);
                const availabilityPriceInfo = availabilityPriceInfoList.filter(a => a.roleName === membershipName);
                const priceBookPrice = priceBookMap === null || priceBookMap === void 0 ? void 0 : priceBookMap.get(variantSKU);
                if (priceBookPrice) {
                    price = Object.assign(Object.assign({}, price), { amount: Math.round((0, utils_1.toCentsFormat)(priceBookPrice.unitPrice)) });
                }
                // non member
                const isForNonmember = !applicableUserRoles.length ||
                    (applicableUserRoles.length && applicableUserRoles[0] === user_1.CORRECT_NON_MEMBER_CHANNEL_KEY)
                    ? {
                        price,
                        applyedDiscountRole: user_1.CORRECT_NON_MEMBER_CHANNEL_KEY,
                        appliedDiscountName: membershipName,
                        transformedPrice: `${(0, utils_1.formatPrice)((0, utils_1.fromCentsFormat)(price.amount), price.currency)}`,
                        isApplicable: true,
                        format: (_a = variant.format) === null || _a === void 0 ? void 0 : _a.key,
                        isPhysicalProduct: variant.isPhysicalProduct,
                        variantsWithAvailableFormatInfo: availabilityPriceInfo,
                    }
                    : null;
                // check if has intersection: price applicableUserRoles and user roles
                // if intersecting, then isApplicable is true, else false
                const isForAllMembers = applicableUserRoles
                    .map(applicableRole => {
                    var _a;
                    const isApplicable = -1 !== userRoles.indexOf(applicableRole);
                    return {
                        price,
                        applyedDiscountRole: applicableRole,
                        appliedDiscountName: membershipName,
                        transformedPrice: `${(0, utils_1.formatPrice)((0, utils_1.fromCentsFormat)(price.amount), price.currency)}`,
                        isApplicable,
                        format: (_a = variant.format) === null || _a === void 0 ? void 0 : _a.key,
                        isPhysicalProduct: variant.isPhysicalProduct,
                        variantsWithAvailableFormatInfo: availabilityPriceInfo,
                    };
                })
                    .reduce((acc, item) => {
                    var _a;
                    // found applicable no need to override acc anymore
                    // in case one user role is present but price channel has multiple MRUSR. Pick the price as applicable.
                    if (acc.isApplicable) {
                        return acc;
                    }
                    return {
                        price: item.price,
                        transformedPrice: item.transformedPrice,
                        appliedDiscountName: (item === null || item === void 0 ? void 0 : item.appliedDiscountName) || null,
                        applyedDiscountRole: item.applyedDiscountRole,
                        isApplicable: item.isApplicable,
                        format: (_a = variant.format) === null || _a === void 0 ? void 0 : _a.key,
                        isPhysicalProduct: variant.isPhysicalProduct,
                        variantsWithAvailableFormatInfo: availabilityPriceInfo,
                    };
                }, {
                    isApplicable: false,
                    price: null,
                    applyedDiscountRole: null,
                    appliedDiscountName: null,
                    transformedPrice: null,
                });
                return isForNonmember || isForAllMembers;
            }
            return null;
        })
            .filter(Boolean)
            .sort((a, b) => sortByDiscountName(a, b));
        // Get the lowest price that are applicable for the user
        let lowestPriceApplicable = pricesMap &&
            pricesMap[variantSKU] &&
            pricesMap[variantSKU].length &&
            pricesMap[variantSKU].filter((a) => {
                return a.isApplicable;
            });
        if (isContribution) {
            lowestPriceApplicable = lowestPriceApplicable.reduce((prev, curr) => {
                return prev.price.amount < curr.price.amount ? prev : curr;
            }, {
                isApplicable: false,
                price: {
                    amount: null,
                },
                applyedDiscountRole: null,
                appliedDiscountName: null,
                transformedPrice: null,
            });
        }
        else {
            lowestPriceApplicable =
                lowestPriceApplicable.length > 1
                    ? lowestPriceApplicable.reduce((prev, curr) => {
                        return prev.price.amount < curr.price.amount ? prev : curr;
                    })
                    : lowestPriceApplicable[0];
        }
        // Assign isLowestApplicablePrice to true if the object has price === to the lowest price applicable
        pricesMap[variantSKU].map((a) => lowestPriceApplicable &&
            a.isApplicable &&
            a.price.amount === lowestPriceApplicable.price.amount &&
            (a.isLowestApplicablePrice = true));
        // Sort the membership names into different arrays
        const nonMember = pricesMap[variantSKU].filter((a) => {
            var _a;
            return ((_a = a === null || a === void 0 ? void 0 : a.appliedDiscountName) === null || _a === void 0 ? void 0 : _a.match(/Nonmembers/)) !== null;
        });
        const member = pricesMap[variantSKU].filter((a) => {
            var _a;
            return ((_a = a === null || a === void 0 ? void 0 : a.appliedDiscountName) === null || _a === void 0 ? void 0 : _a.match(/AICPA|CIMA\sMembers/)) !== null;
        });
        const sortedSectionMembers = pricesMap[variantSKU].filter((a) => {
            var _a;
            return ((_a = a === null || a === void 0 ? void 0 : a.appliedDiscountName) === null || _a === void 0 ? void 0 : _a.match(/Section\sMembers/)) !== null;
        });
        const sortedCredentialHolders = pricesMap[variantSKU].filter((a) => {
            var _a;
            return ((_a = a === null || a === void 0 ? void 0 : a.appliedDiscountName) === null || _a === void 0 ? void 0 : _a.match(/Credential\sHolders/)) !== null;
        });
        const sortedDesignationHolders = pricesMap[variantSKU].filter((a) => {
            var _a;
            return ((_a = a === null || a === void 0 ? void 0 : a.appliedDiscountName) === null || _a === void 0 ? void 0 : _a.match(/Designation\sHolders/i)) !== null;
        });
        const freeTrialPrice = pricesMap[variantSKU].filter((a) => {
            var _a;
            return ((_a = a === null || a === void 0 ? void 0 : a.appliedDiscountName) === null || _a === void 0 ? void 0 : _a.match(/Free\strial/)) !== null;
        });
        // Concat all arrays into the order based on the acceptance criteria
        pricesMap[variantSKU] = nonMember
            .concat(member)
            .concat(sortedSectionMembers)
            .concat(sortedCredentialHolders)
            .concat(sortedDesignationHolders)
            .concat(freeTrialPrice);
        return pricesMap;
    }, {});
};
exports.userApplicableVariantsPricing = userApplicableVariantsPricing;
const variantsPriceInfoForUser = (variantPricesForUser) => {
    const initialValue = {};
    return Object.entries(variantPricesForUser).reduce((transformed, [variantSKU, variantPrice]) => {
        var _a, _b;
        const freeTrialPrice = (_a = variantPrice.find(p => p.applyedDiscountRole === mxp_schemas_1.User.MembershipIdsEnum.FREE_TRIAL)) === null || _a === void 0 ? void 0 : _a.price;
        const freeTrialPriceAmount = (freeTrialPrice === null || freeTrialPrice === void 0 ? void 0 : freeTrialPrice.amount) || 0;
        const nonMember = variantPrice.filter(applicablePricesForRole => applicablePricesForRole &&
            applicablePricesForRole.applyedDiscountRole === user_1.CORRECT_NON_MEMBER_CHANNEL_KEY &&
            applicablePricesForRole.isApplicable)[0] || null;
        const hasApplicablePrice = variantPrice.some(applicablePricesForRole => applicablePricesForRole === null || applicablePricesForRole === void 0 ? void 0 : applicablePricesForRole.isApplicable);
        const priceNameSorted = variantPrice
            .filter((a) => {
            return !Boolean(nonMember) && !hasApplicablePrice ? true : a.isApplicable;
        })
            .map(price => (Object.assign(Object.assign({}, price), { membershipName: price ? user_1.membershipDiscountMapNames[price.applyedDiscountRole] : '' })))
            .sort((a, b) => sortByPrice(a, b) || sortByName(a, b));
        const lowest = priceNameSorted.length ? priceNameSorted[0] : null;
        const currency = nonMember ? nonMember.price.currency : ((_b = lowest === null || lowest === void 0 ? void 0 : lowest.price) === null || _b === void 0 ? void 0 : _b.currency) || 'USD';
        const priceFullAmount = nonMember ? nonMember.price.amount : 0;
        const priceLowestAmount = lowest ? lowest.price.amount : 0;
        const priceDiscountAmount = priceFullAmount - priceLowestAmount;
        const discountLabel = `${lowest ? lowest.membershipName : ''} Discount`;
        transformed[variantSKU] = {
            priceFull: Object.assign({ label: 'Nonmember Price', formattedPrice: (0, utils_1.formatPrice)((0, utils_1.fromCentsFormat)(priceFullAmount), currency) }, (nonMember && nonMember.price ? nonMember.price : {})),
            discountAmount: priceDiscountAmount
                ? {
                    label: discountLabel,
                    formattedPrice: `-${(0, utils_1.formatPrice)((0, utils_1.fromCentsFormat)(priceDiscountAmount), currency)}`,
                    amount: priceDiscountAmount,
                }
                : null,
            priceFinal: Object.assign({ label: 'Price excluding applicable tax', formattedPrice: (0, utils_1.formatPrice)((0, utils_1.fromCentsFormat)(priceLowestAmount), currency) }, (lowest && lowest.price ? lowest.price : {})),
            hasNonMemberPrice: Boolean(nonMember),
        };
        if (freeTrialPrice) {
            transformed[variantSKU].freeTrialPrice = Object.assign({ label: 'Free trial', formattedPrice: (0, utils_1.formatPrice)((0, utils_1.fromCentsFormat)(freeTrialPriceAmount), currency) }, freeTrialPrice);
        }
        return transformed;
    }, initialValue);
};
exports.variantsPriceInfoForUser = variantsPriceInfoForUser;
const transformRoles = (price) => {
    const roles = (price && price.channel && price.channel.applicableUserRoles ? price.channel.applicableUserRoles || [] : []);
    // Get the membership name of the first role since there are roles mapped to two membership IDs.
    return price ? user_1.membershipNamesForPricingTable[roles[0]] : '';
};
const transformCpeCredits = (variants, isBundleProduct) => {
    const present = new Date().toISOString();
    // filter variant credits by actual values ascending, without duplicates
    const cpeCreditRange = variants
        .filter((variant) => (((variant === null || variant === void 0 ? void 0 : variant.startDate) && (variant === null || variant === void 0 ? void 0 : variant.startDate) > present) || isBundleProduct) && Boolean(variant === null || variant === void 0 ? void 0 : variant.credits))
        .map((variant) => variant === null || variant === void 0 ? void 0 : variant.credits)
        .sort((a, b) => a - b);
    // new Set for unique values
    return [...new Set(cpeCreditRange)];
};
exports.transformCpeCredits = transformCpeCredits;
const getUpcomingVariants = (variants) => {
    const currTime = new Date().toISOString();
    return variants.filter(
    // we do not filter out multiday or series variants as the dates are driven by their children products
    // added new condition for conference that is already started but not yet ended
    (variant) => variant.productType === mxp_schemas_1.Product.AvailableFormat.SERIES ||
        variant.productType === mxp_schemas_1.Product.AvailableFormat.MULTI_DAY ||
        isConferenceStarted(variant) ||
        !(variant === null || variant === void 0 ? void 0 : variant.startDate) ||
        (variant === null || variant === void 0 ? void 0 : variant.startDate) > currTime);
};
exports.getUpcomingVariants = getUpcomingVariants;
const transformVariantPricesToAvailabilityInfo = (variants, currencyPrice, tier, priceBookPrices) => {
    const availabilityPriceInfo = variants
        .reduce((pricesMap, variant) => {
        var _a;
        if (variant.prices && variant.prices.length) {
            const variantSKU = variant.sku;
            const variantInfo = (_a = (0, utils_1.getUpdatedPrices)(variant === null || variant === void 0 ? void 0 : variant.prices, currencyPrice, tier)) === null || _a === void 0 ? void 0 : _a.map((price) => {
                var _a;
                if (price.channel.applicableUserRoles) {
                    const priceBookPrice = priceBookPrices === null || priceBookPrices === void 0 ? void 0 : priceBookPrices.get(variantSKU);
                    if (priceBookPrice) {
                        price = Object.assign(Object.assign({}, price), { amount: Math.round((0, utils_1.toCentsFormat)(priceBookPrice.unitPrice)) });
                    }
                    return {
                        sku: variant.sku,
                        transformedPrice: `${(0, utils_1.formatPrice)((0, utils_1.fromCentsFormat)(price.amount), price.currency)}`,
                        format: (_a = variant.format) === null || _a === void 0 ? void 0 : _a.label,
                        roleName: transformRoles(price),
                        amount: price.amount,
                        optionalText: variant.optionalText,
                        startDateTime: variant.startDateTime,
                        endDateTime: variant.endDateTime,
                    };
                }
            }).filter(Boolean);
            pricesMap.push(...variantInfo);
        }
        return pricesMap;
    }, [])
        .sort((a, b) => a.amount - b.amount);
    return availabilityPriceInfo;
};
// Unindexable product types for B2C search and content
const unindexableProducts = [
    mxp_schemas_1.Product.ProductType.DISCONTINUED,
    mxp_schemas_1.Product.ProductType.NON_STORE,
    mxp_schemas_1.Product.ProductType.ONSITE,
];
const includesUnindexableProducts = (element) => unindexableProducts.includes(element);
exports.includesUnindexableProducts = includesUnindexableProducts;
// created to check if the conference is already started but not yet ended
const isConferenceStarted = (variant) => {
    const currTime = new Date().toISOString();
    return ((variant.productType === mxp_schemas_1.Product.AvailableFormat.FLEX_PASS_CONFERENCE ||
        variant.productType === mxp_schemas_1.Product.AvailableFormat.ONLINE_CONFERENCE ||
        variant.productType === mxp_schemas_1.Product.AvailableFormat.ONSITE_CONFERENCE) &&
        (!(variant === null || variant === void 0 ? void 0 : variant.startDate) || ((variant === null || variant === void 0 ? void 0 : variant.startDate) < currTime && !(variant === null || variant === void 0 ? void 0 : variant.endDate)) || (variant === null || variant === void 0 ? void 0 : variant.endDate) > currTime));
};
exports.FETCH_PRODUCTS_EXPANSION_PART = 'expand=masterData.current.masterVariant.prices[*].channel.id&expand=masterData.current.variants[*].prices[*].channel.id&expand=masterData.current.variants[*].availability[*].channel.id&expand=productType&expand=masterData.current.categories[*]&expand=masterData.current.masterVariant.attributes[*].value[*]';
const getProductPrice = (product, variantSKU, userRoles, currencyPrice, userLocation) => {
    const variantsPriceInfoForUserRole = (0, exports.variantsPriceInfoForUser)((0, exports.userApplicableVariantsPricing)(product.variants, userRoles, false, currencyPrice || mxp_schemas_1.Product.ProductCurrencyLabel.USD, userLocation || mxp_schemas_1.Checkout.Tiers.TIER1));
    return variantsPriceInfoForUserRole[variantSKU];
};
exports.getProductPrice = getProductPrice;
const attributesToObject = (attributes) => attributes.reduce((acc, attribute) => (Object.assign(Object.assign({}, acc), { [attribute.name]: attribute.value })), {});
exports.attributesToObject = attributesToObject;
const isVariantWithValidPrice = (variant, currencyPrice, tier) => {
    const updatedPrices = tier ? (0, utils_1.getUpdatedPrices)(variant.prices, currencyPrice, tier) : variant.prices;
    const maxVariantPrice = Math.max(Number.NEGATIVE_INFINITY, ...updatedPrices.map(price => price.amount));
    return maxVariantPrice !== Number.NEGATIVE_INFINITY && !isNaN(maxVariantPrice);
};
exports.isVariantWithValidPrice = isVariantWithValidPrice;
const isVariantWithValidDates = (variant) => {
    const present = (0, moment_1.default)();
    const isConference = variant.productType === mxp_schemas_1.Product.ProductType.CONFERENCE;
    return (!variant.startDateTime ||
        present.isBefore(variant.startDateTime) ||
        (isConference &&
            (!(variant === null || variant === void 0 ? void 0 : variant.startDateTime) || present.isAfter(variant === null || variant === void 0 ? void 0 : variant.startDateTime)) &&
            (!(variant === null || variant === void 0 ? void 0 : variant.endDateTime) || present.isBefore(variant === null || variant === void 0 ? void 0 : variant.endDateTime))));
};
exports.isVariantWithValidDates = isVariantWithValidDates;
const checkProductMembershipApplicationType = (lineItems) => {
    const membershipBodyFound = Object.values(mxp_schemas_1.Product.MembershipApplicationType).filter((membershipBody) => lineItems === null || lineItems === void 0 ? void 0 : lineItems.some(lineItem => {
        var _a, _b, _c;
        return ((_c = (_b = (_a = lineItem.variant) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.membershipBody) === null || _c === void 0 ? void 0 : _c.key) === membershipBody &&
            (lineItem === null || lineItem === void 0 ? void 0 : lineItem.productType) !== mxp_schemas_1.Product.ProductType.CONTRIBUTION;
    }));
    if (!!membershipBodyFound)
        return membershipBodyFound[0];
};
exports.checkProductMembershipApplicationType = checkProductMembershipApplicationType;
const getProductMembershipApplicationTypes = (lineItems) => {
    const membershipBodyFound = Object.values(mxp_schemas_1.Product.MembershipApplicationType).filter((membershipBody) => lineItems === null || lineItems === void 0 ? void 0 : lineItems.some(lineItem => { var _a, _b, _c; return ((_c = (_b = (_a = lineItem.variant) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.membershipBody) === null || _c === void 0 ? void 0 : _c.key) === membershipBody; }));
    return membershipBodyFound;
};
exports.getProductMembershipApplicationTypes = getProductMembershipApplicationTypes;
const isMembershipProduct = (item) => {
    var _a, _b;
    return Boolean(((_b = (_a = item === null || item === void 0 ? void 0 : item.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.key) === mxp_schemas_1.Product.ProductType.MEMBERSHIP);
};
exports.isMembershipProduct = isMembershipProduct;
const isCenterMembershipProduct = (item) => {
    var _a, _b;
    return Boolean(((_b = (_a = item === null || item === void 0 ? void 0 : item.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.key) === mxp_schemas_1.Product.ProductType.CENTER_MEMBERSHIP);
};
exports.isCenterMembershipProduct = isCenterMembershipProduct;
const isCredentialProduct = (item) => {
    var _a, _b;
    return Boolean(((_b = (_a = item === null || item === void 0 ? void 0 : item.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.key) === mxp_schemas_1.Product.ProductType.CREDENTIAL);
};
exports.isCredentialProduct = isCredentialProduct;
const isSectionProduct = (item) => {
    var _a, _b;
    return Boolean(((_b = (_a = item === null || item === void 0 ? void 0 : item.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.key) === mxp_schemas_1.Product.ProductType.SECTION);
};
exports.isSectionProduct = isSectionProduct;
const isCenterMembership = (item) => {
    var _a, _b;
    return Boolean(((_b = (_a = item === null || item === void 0 ? void 0 : item.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.key) === mxp_schemas_1.Product.ProductType.CENTER_MEMBERSHIP);
};
exports.isCenterMembership = isCenterMembership;
const isCertificateProduct = (item) => {
    var _a, _b;
    return Boolean(((_b = (_a = item === null || item === void 0 ? void 0 : item.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.key) === mxp_schemas_1.Product.ProductType.CERTIFICATE);
};
exports.isCertificateProduct = isCertificateProduct;
const isFeeProduct = (item) => {
    var _a, _b;
    return Boolean(((_b = (_a = item === null || item === void 0 ? void 0 : item.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.key) === mxp_schemas_1.Product.ProductType.FEE);
};
exports.isFeeProduct = isFeeProduct;
exports.membershipBodyToLegalEntity = {
    [mxp_schemas_1.Product.ProductMembershipBody.AICPA]: mxp_schemas_1.Salesforce.LegalEntity.ASSOCIATION,
    [mxp_schemas_1.Product.ProductMembershipBody.CIMA]: mxp_schemas_1.Salesforce.LegalEntity.CIMA,
};
const getRenewalSeasonValue = (isRenewalSeason, valueIfTrue, valueIfFalse) => {
    return isRenewalSeason ? valueIfTrue : valueIfFalse;
};
exports.getRenewalSeasonValue = getRenewalSeasonValue;
const getSubscriptionEndDateForCancelPayload = (item) => {
    if (item === null || item === void 0 ? void 0 : item.zuoraTermEndDate)
        return item.zuoraTermEndDate;
    else if ((item === null || item === void 0 ? void 0 : item.subscriptionTermType) === mxp_schemas_1.Orders.TermType.EVERGREEN && (item === null || item === void 0 ? void 0 : item.ratePlanChargedThroughDate)) {
        /* For EVERGREEN Term type products wont have term end date, use rateplan chargedThroughDate instead */
        return item.ratePlanChargedThroughDate;
    }
    return '';
};
exports.getSubscriptionEndDateForCancelPayload = getSubscriptionEndDateForCancelPayload;
const createCancelPayload = (item, cancelRefundData, amount) => {
    return [
        {
            orderId: (item === null || item === void 0 ? void 0 : item.orderId) || '',
            sku: (item === null || item === void 0 ? void 0 : item.sku) || '',
            subscriptionNumber: (item === null || item === void 0 ? void 0 : item.subscriptionNumber) || '',
            subscriptionStartDate: cancelRefundData.isCalculateProrationClicked
                ? (0, moment_1.default)().format('YYYY-MM-DD')
                : item === null || item === void 0 ? void 0 : item.zuoraTermStartDate,
            ratePlanId: (item === null || item === void 0 ? void 0 : item.ratePlanId) || '',
            isAutoRenewable: Boolean(item === null || item === void 0 ? void 0 : item.isAutoRenewable),
            isOnlyProductOnSubscription: Boolean(item === null || item === void 0 ? void 0 : item.isOnlyProductOnSubscription),
            subscriptionEndDate: (0, exports.getSubscriptionEndDateForCancelPayload)(item),
            zuoraProductId: item === null || item === void 0 ? void 0 : item.zuoraProductId,
            amount,
            reason: cancelRefundData.reason,
            shouldCancelFromStartDate: Boolean(item === null || item === void 0 ? void 0 : item.isAutoRenewable) &&
                !cancelRefundData.isCalculateProrationClicked &&
                (cancelRefundData.requiredAction === mxp_schemas_1.Product.RefundOrCancellationEnums.CANCEL_AND_MOVE ||
                    cancelRefundData.requiredAction === mxp_schemas_1.Product.RefundOrCancellationEnums.REFUND_WITH_CANCELLATION),
            isEndOfLastInvoicePeriod: (item === null || item === void 0 ? void 0 : item.zuoraTermEndDate) ? false : true,
        },
    ];
};
exports.createCancelPayload = createCancelPayload;
const createRefundPayload = (item, cancelRefundData, amount) => {
    return {
        zuoraPayload: [
            {
                skuName: (item === null || item === void 0 ? void 0 : item.sku) || '',
                subscriptionNumber: (item === null || item === void 0 ? void 0 : item.subscriptionNumber) || '',
                amount,
                reason: cancelRefundData.reason,
                zuoraProductId: (item === null || item === void 0 ? void 0 : item.zuoraProductId) || '',
            },
        ],
        cancelAction: cancelRefundData.requiredAction,
        productType: mxp_schemas_1.Product.ProductType.MEMBERSHIP,
        productStatus: mxp_schemas_1.Product.ProductCancellationStatus.RESIGNED,
    };
};
exports.createRefundPayload = createRefundPayload;
//# sourceMappingURL=index.js.map